const enVendors = {
  vendors: {
    label: {
      title: 'Vendor',
      name: 'Name',
      email: 'Email',
      financialEmail: 'Financial Email',
      document: 'Document',
      createdAt: 'Created at',
      description: 'Description',
      hostServicePhone: 'Host Service Phone',
      customerServicePhone: 'Customer Service Phone',
      vendorLogo: 'Vendor Logo',
      details: 'Details',
      paymentInfo: 'Payment Information'
    },

    action: {
      cancel: 'Cancel',
      edit: 'Edit vendor',
      create: 'New vendor',
      delete: 'Delete vendor',
      loading: 'Loading vendor',
      save: 'Save',
      update: 'Update',
    },

    hints: {
      delete: 'Do you really want to delete this vendor?',
      vendorNotFound: 'Vendor not found',
    },

    messages: {
      successfullyCreated: 'Vendor created successfully',
      successfullyUpdated: 'Vendor updated successfully',
      successfullyDeleted: 'Vendor removed successfully',
    },
  },
}

export default enVendors;
